var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex text-gray-500 mt-2"},[_vm._v("\n    "+_vm._s(_vm.$t('search_in_progress'))+"\n    "),_c('BoucingDots',{staticClass:"ml-1 text-xl"})],1),_vm._v(" "),_c('ProductListPlaceholder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }